import { getBrand } from '@helpers/brand.utils';

const QUALTRIC_CONFIG = {
  AHS: {
    scriptPath: 'statics/ahs/ahsqualtricsurvey.js',
    divId: 'ZN_6KCRZLGLBkqiH7T',
  },
  HSA: {
    scriptPath: 'statics/hsa/hsaqualtricsurvey.js',
    divId: 'ZN_8Jqg8Kflepcukol',
  },
};

export function loadQualtric(delayToStart: number = 10000) {
  const brand = getBrand();
  const config = QUALTRIC_CONFIG[brand];

  if (!config) return;

  if (!document.getElementById(config.divId)) {
    const div = document.createElement('div');
    div.id = config.divId;
    document.body.appendChild(div);
  }

  setTimeout(() => {
    const src = `${process.env.ASSET_PATH}${config.scriptPath}`;

    if (!document.querySelector(`script[src="${src}"]`)) {
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      document.body.appendChild(script);
    }
  }, delayToStart);
}
